import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";


export default function OurStory() {
  const [visible, setVisible] = useState({});
  const itemRefs = useRef([]);
  const { t } = useTranslation();

  const historyItems = [
    { year: "2017", month: t("section3.4"), desc: t("section3.201704"), num: "01" },
    { year: "2021", month: t("section3.12"), desc: t("section3.202112"), num: "02" },
    { year: "2022", month: t("section3.7"), desc: t("section3.202207"), num: "03" },
    { year: "2022", month: t("section3.12"), desc: t("section3.202212_1"), num: "04" },
    { year: "2022", month: t("section3.12"), desc: t("section3.202212_2"), num: "05" },
    { year: "2023", month: t("section3.7"), desc: t("section3.202307"), num: "06" },
    { year: "2023", month: t("section3.12"), desc: t("section3.202312"), num: "07" },
    { year: "2026", month: t("section3.5"), desc: t("section3.202605"), num: "08" },
  ];

  useEffect(() => {
    const observers = [];

    itemRefs.current.forEach((el, i) => {
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          setVisible((prev) => ({ ...prev, [i]: entry.isIntersecting }));
        },
        { threshold: 0.1 } // 0.7 → 0.1 낮춰서 모바일에서도 잘 잡히게
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  return (
    <div className="py-10 overflow-hidden"> {/* overflow-hidden 추가 */}
      <div className="flex flex-col gap-2.5">
        {historyItems.map((item, index) => (
          <div
            key={item.num}
            ref={(el) => (itemRefs.current[index] = el)}
            style={{
              transition: "opacity 0.8s ease, transform 0.8s ease",
              opacity: visible[index] ? 1 : 0,
              // 모바일에서 너무 크지 않게 줄임
              transform: visible[index] ? "translateX(0)" : "translateX(-60px)",
            }}
            className="flex items-center"
          >
            {/* 연도 태그 */}
            <div className="bg-sky-200 text-sky-800 rounded-l-full px-4 md:px-6 py-3 md:py-3.5 w-24 md:w-36 shrink-0 font-bold text-xs md:text-sm tracking-widest">
              {item.year}
            </div>

            {/* 바 */}
            <div className="bg-gray-50 rounded-r-full flex items-center gap-2 md:gap-4 px-3 md:px-6 py-3 md:py-3.5 flex-1 -ml-px min-w-0">
              <span className="text-[10px] md:text-[11px] font-bold tracking-wider uppercase text-gray-400 shrink-0 block md:hidden">
                {item.month}
              </span>
              <div className="w-px h-5 bg-gray-200 md:hidden block" />
              <span className="text-xs md:text-sm font-medium text-gray-700 truncate">
                {item.desc}
              </span>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
}